import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  createNewStag,
  authStatusSelector,
  networkStatusSelector,
} from '../../../reducers';
import NewStag from './component';

const mapStateToProps = (state) => {
  return {
    loading: false,
    authenticated: authStatusSelector(state),
    networkStatus: networkStatusSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    createNewStag,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NewStag);



// WEBPACK FOOTER //
// ./src/component/organisms/NewStag/index.js